<img [src]="getImagePath()">
<ng-content></ng-content>